<h2 class="mb-6">Confirm cleaning details for {{ property()?.name || '6543 Maplewood Drive' }}</h2>

<div class="flex flex-col gap-6">
  <!-- Rooms input (disabled) -->
  <div class="flex flex-col md:flex-row items-start md:items-center gap-2 justify-between">
    <div class="flex flex-col gap-2">
      <span class="font-semibold">Bedrooms</span>
      <span class="text-text-tertiary">Bedrooms to clean</span>
    </div>

    <ui-numeric-input-stepper class="w-44" [ngModel]="rooms()" [disabled]="true" [min]="0" [max]="50" [step]="1" />
  </div>

  <!-- Bathrooms input (disabled) -->
  <div class="flex flex-col md:flex-row items-start md:items-center gap-2 justify-between">
    <div class="flex flex-col gap-2">
      <span class="font-semibold">Bathrooms</span>
      <span class="text-text-tertiary">Full and half bathrooms</span>
    </div>

    <ui-numeric-input-stepper
      class="w-44"
      [ngModel]="bathrooms()"
      [disabled]="true"
      [min]="0"
      [max]="10"
      [step]="0.5"
      [allowDecimals]="true" />
  </div>

  <!-- Cleaning time input -->
  <div class="flex flex-col md:flex-row items-start md:items-center gap-2 justify-between">
    <div class="flex flex-col gap-2">
      <span class="font-semibold">Cleaning time (hours)</span>
      <span class="text-text-tertiary">
        @if (recommendedCleaningTime()) {
          Adjust if needed, we recommend {{ recommendedCleaningTime() }} hours.
        } @else {
          Adjust if needed
        }
      </span>
    </div>

    <ui-numeric-input-stepper
      class="w-44"
      [ngModel]="cleaningHours()"
      (ngModelChange)="cleaningHoursChanged.emit($event)"
      [min]="0"
      [max]="24"
      [step]="0.25"
      [allowDecimals]="true" />
  </div>

  <!-- Provide cleaning supplies checkbox -->
  <ui-checkbox-wrapped
    [checked]="provideCleaningSupplies()"
    (checkedChange)="provideCleaningSuppliesChanged.emit($event)">
    <div class="flex flex-col w-full p-3 text-base">
      <strong>I will provide cleaning supplies</strong>
      <span class="text-text-tertiary">If left unchecked, the cleaner will bring their own.</span>
    </div>
  </ui-checkbox-wrapped>

  <!-- Integration alerts -->
  @if (turnoIntegrationEnabled()) {
    <ui-alert type="inline" color="error" icon="griddy-info-circle" [hideCloseButton]="true">
      <div class="flex flex-col gap-2">
        <strong>It looks like you have an active integration with Turno.</strong>
        <p
          >If you activate this autopilot cleaning task, we'll only schedule tasks for new reservations without a task
          assigned yet. To avoid duplicate tasks, you'll need to disable new task creation in your integration
          provider.</p
        >
      </div>
    </ui-alert>
  }

  @if (cleansterIntegrationEnabled()) {
    <ui-alert type="inline" color="error" icon="griddy-info-circle" [hideCloseButton]="true">
      <div class="flex flex-col gap-2">
        <strong>It looks like you have an active integration with Cleanster.</strong>
        <p
          >If you activate this autopilot cleaning task, we'll only schedule tasks for new reservations without a task
          assigned yet. To avoid duplicate tasks, you'll need to disable new task creation in your integration
          provider.</p
        >
      </div>
    </ui-alert>
  }

  @if (resortCleaningIntegrationEnabled()) {
    <ui-alert type="inline" color="error" icon="griddy-info-circle" [hideCloseButton]="true">
      <div class="flex flex-col gap-2">
        <strong>It looks like you have an active integration with Resort Cleaning.</strong>
        <p
          >If you activate this autopilot cleaning task, we'll only schedule tasks for new reservations without a task
          assigned yet. To avoid duplicate tasks, you'll need to disable new task creation in your integration
          provider.</p
        >
      </div>
    </ui-alert>
  }

  @if (tidyIntegrationEnabled()) {
    <ui-alert type="inline" color="error" icon="griddy-info-circle" [hideCloseButton]="true">
      <div class="flex flex-col gap-2">
        <strong>It looks like you have an active integration with TIDY.</strong>
        <p
          >If you activate this autopilot cleaning task, we'll only schedule tasks for new reservations without a task
          assigned yet. To avoid duplicate tasks, you'll need to disable new task creation in your integration
          provider.</p
        >
      </div>
    </ui-alert>
  }
</div>
